(($, Drupal) => {
    Drupal.behaviors.gridLink = {
        attach: function attach() {

            $(".container-switcher__item").once("grid-link").each(function(index, item) {
                
                const gridLink = $(this).find(".grid-link");
                $(gridLink).each(function(index, item) {
                    if(index > 4) {
                        if(index == 5) {
                            const parent = $(gridLink).parent();
                            
                            const translateText = {
                                "show": $(".show-hide-text").data("show"),
                                "hide": $(".show-hide-text").data("hide")
                            }
                            const buttonMore = $("<div>", { class: "button bordered title-weight" }).text(translateText["show"]);
                            let opened = false;
    
                            const elements = $(parent.find(".grid-link"));
                            buttonMore.on("click", function() {
                                opened = !opened;
                                if(opened) {
                                    buttonMore.text(translateText["hide"])
                                    elements.each(function(index, item) {
                                        if(index > 4) {
                                            $(item).removeClass("hide");
                                        }
                                    })
                                }
                                else {
                                    buttonMore.text(translateText["show"])
                                    elements.each(function(index, item) {
                                        if(index > 4) {
                                            $(item).addClass("hide");
                                        }
                                    })
                                }
                            })
                            const buttonMoreWrapper = $("<div>", { class: "container__grid-item solid", style: "align-items: center; padding: 30px 0; cursor:pointer;" }).append(buttonMore);
                            
                            parent.append(buttonMoreWrapper)
                        }
                        $(this).addClass("hide");
                       
                    }
                })
                
            });
        }
    };

})(jQuery, Drupal);
  